<template>
	<div>
		<div class="page-tit">
			<span>{{pageTit}}</span>
			<a href="javascript:;" v-if="!pageShow.infos" @click="pageTabFn('infos')">
				<i>&lt;</i>返 回
			</a>
		</div>
		<div class="account-main">
			<transition name="page" mode="out-in">
				<ul class="account-info" v-if="pageShow.infos">
					<li>
						<i class="el-icon-circle-check"></i>
						<span>站神账号</span>
						<span>登录账号：{{userInfo.username}}</span>
						<span>登录密码：**********</span>
						<a href="javascript:;" @click="pageTabFn('password')"><i class="iconfont icon-xiugai"></i> 修改</a>
					</li>
					<li>
						<i class="el-icon-circle-check"></i>
						<span>手机绑定</span>
						<span>您的手机：{{userInfo.moblie}}</span>
						<em>（可用于登录、找回密码）</em>
						<a href="javascript:;" @click="pageTabFn('phone')"><i class="iconfont icon-xiugai"></i>修改</a>
					</li>
					<li>
						<i :class="userInfo.qrOpenid == ''?'el-icon-warning-outline':'el-icon-circle-check'"></i>
						<span>绑定运营人员微信</span>
						<em>（绑定后 可用该微信号快速登录）</em>
						<a href="javascript:;" @click="pageTabFn('wx')"><i class="iconfont icon-xiugai"></i>{{userInfo.qrOpenid == ''?'立即绑定':'解绑'}}</a>
					</li>
					<!-- <li>
						<i class="icon" :class="userInfo.pmOpenid == ''?'i-point':'i-success'"></i>
						<span>绑定老板微信</span>
						<span>绑定后，可用于及时收到网站备案，上课通知，网站上线等重要信息提醒</span>
						<a href="javascript:;" @click="pageTabFn('bosswx')">{{userInfo.pmOpenid == ''?'立即绑定':'解绑'}}</a>
					</li> -->
				</ul>
			</transition>
			<transition name="page" mode="out-in">
				<edit-phone v-if="pageShow.phone" @Close="pageTabFn('infos')"></edit-phone>
			</transition>
			<transition name="page" mode="out-in">
				<edit-password v-if="pageShow.password" @Close="pageTabFn('infos')"></edit-password>
			</transition>
			<transition name="page" mode="out-in">
				<edit-wx v-if="pageShow.wx" @Close="pageTabFn('infos')"></edit-wx>
			</transition>
			<transition name="page" mode="out-in">
				<boss-wx v-if="pageShow.bosswx"  @Close="pageTabFn('infos')"></boss-wx>
			</transition>
		</div>

		<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
	</div>
</template>

<script>
import editPhone from './EditPhone'
import editPassword from './EditPassword'
import editWx from './EditWx'
import bossWx from './BossWx'
import {
	mapGetters,
	mapActions
} from 'vuex'
import mixinDialog from '@/mixins/mixinsDialog'

export default {
	name: 'accountInfo',
	data () {
		return {
			pageTit: '快捷登录',
			opendType: '',
			pageShow: {
				infos: true,
				phone: false,
				password: false,
				wx: false,
				bosswx:false
			}
		}
	},
	created() {
		if(this.$route.query.isBoosWx){
			this.pageTabFn('bosswx')
		}
	},
	mixins: [mixinDialog],
	watch: {
		pageShow () {
			if (this.pageShow.infos) {
				this.pageTit = '快捷登录'
			} else if (this.pageShow.phone) {
				this.pageTit = '修改手机号码'
			} else if (this.pageShow.password) {
				this.pageTit = '修改密码'
			} else if (this.pageShow.wx) {
				this.pageTit = '绑定微信'
			}else if (this.pageShow.bosswx) {
				this.pageTit = '绑定老板微信'
			}
		}
	},
	methods: {
		...mapActions('user', ['getFrontUserInfo', 'getUnbingQrOpenid']),
		pageTabFn (code) {
			if (this.userInfo.qrOpenid != '' && code == 'wx') {
				this.opendType = 'qrOpen'
				this.openErrDialog('ask', '操作信息提示', 'relieveFn', '', '您确定要解除微信绑定吗？', '确定')
				return
			}
			if (this.userInfo.pmOpenid != '' && code == 'bosswx') {
				this.opendType = 'pmOpen'
				this.openErrDialog('ask', '操作信息提示', 'relieveFn', '', '您确定要解除老板微信绑定吗？', '确定')
				return
			}
			this.pageShow = {
				infos: false,
				phone: false,
				password: false
			}
			this.pageShow[code] = true
			if (code == 'infos') {
				this.getFrontUserInfo()
			}
		},
		// 解除绑定
		relieveFn (type) {
			let params = {
				username: this.userInfo.username,
				opendType: this.opendType
			}
			this.getUnbingQrOpenid(params).then(res => {
				if (res.data.isSuccess) {
					//解绑后登陆界面默认验证码登录
					window.localStorage.loginStatus = false
					this.$message({
						message: '解除绑定成功',
						type: 'success'
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
				this.getFrontUserInfo()
				this.showDialog = false
			})
		}
	},
	components: {
		editPhone,
		editPassword,
		editWx,
		bossWx
	},
	computed: {
		...mapGetters('user', [
			'userInfo'
		])
	},
}

</script>


<style lang="scss" scoped>
.account-main{
	background:rgba(255,255,255,1);
	border-radius:4px;
	padding: 60px 0 38px 120px;
}
.account-info {
	// position: absolute;
	// top: 172px;
	width: 885px;

	li {
		// margin: 50px 60px 0 0;
		line-height: 30px;
		margin-bottom: 22px;
		display: flex;
		align-items: center;
			font-size: 14px;
			color: #212121;
		span {
			margin-right: 20px;
			vertical-align: middle;
		}
		em{
			margin-left: -10px;
			margin-right: 20px;
			color: #939AA3;
		}
		i{
			margin-right: 10px;
			font-size: 16px;
			&.el-icon-warning-outline{
				color: #FF0000;
			}
			&.el-icon-circle-check{
				color: #53CF8E;
			}
		}

		a {
			float: right;
			margin-top: 3px;
			color: $colorA;
			font-size: 14px;
			line-height: 14px;
			i{
				margin-right: 6px;
			}
			// &:hover {
			// 	color: $colorA;
			// 	border-bottom: 1px solid $colorA;
			// }
		}
	}
}
</style>
